import React, { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";
import toastr from "toastr";

//redux
import {
  getMetricaCompetencias,
  deleteMetricaCompetencias,
  editMetricaCompetencias,
  saveMetricaCompetencias,
  resetMetricaCompetencias,
  // getUltimoRegistro,
} from "../../../redux/evaluacion_desempenio/metricaCompetencia/actions";
import {
  getPeriodicity,
  getPeriodicityByOrg,
  resetPeriodicity,
  resetPeriodicityByOrg,
} from "../../../redux/evaluacion_desempenio/Periodicity/actions";
import {
  getClassification,
  saveClassification,
  editClassification,
  deleteClassification,
} from "../../../redux/Classification/actions";
import { getOrgs } from "../../../redux/organization/actions";

//el nombre como llega en la api
const schema = Yup.object().shape({
  nombre: Yup.string().ensure().required("**Campo requerido"),
  descripcion: Yup.string().ensure().required("**Campo requerido"),
  valor_minimo: Yup.number()
    .integer("El número no puede tener decimales.")
    .required("**Campo requerido")
    .min(0, "El número no puedo ser menor a 0"),
  valor_maximo: Yup.number()
    .integer("El número no puede tener decimales.")
    .required("**Campo requerido")
    .min(0, "El número no puedo ser menor a 0"),
  valor_porcentual: Yup.number()
    .integer("El número no puede tener decimales.")
    .required("**Campo requerido")
    .min(0, "El número no puedo ser menor a 0"),
  grado: Yup.number()
    .integer("El número no puede tener decimales.")
    .required("**Campo requerido")
    .min(1, "El número no puedo ser menor a 1")
    .max(5, "El número no puedo ser mayor de 5"),
});

const MetricaCompetencia = (props) => {
  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);
  const [periodos, setperiodos] = useState([]);
  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const [ultimoGrado, setUltimoGrado] = useState(1);

  const [isOrgSelect, setIsOrgSelect] = useState(false);
  const [_empresa, setEmpresa] = useState("");
  const [_periodo, setPeriodo] = useState("");
  const [_clasificacion, setClasificacion] = useState("");

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Nombre",
  });

  const dispatch = useDispatch();
  const fecha = new Date();
  var n = fecha.getFullYear();

  const metricaCompetenciaStore = useSelector(
    (store) => store.metricaCompetencia
  );
  const {
    loaderMetricaCompetencia,
    metricaCompetencia,
    metricaCompetenciaFalla,
    saveLoaderMetricaCompetencia,
    metricaCompetenciaFormError,
    ultimoRegistro,
    loaderUltimoRegistro,
  } = metricaCompetenciaStore;

  const {
    loading: loadingPeriodicity,
    saveLoading: saveLoadingPeriodicity,
    periodicity,
    periodicityError,
    formError: formErrorPeriodicity,
    periodicitys,
    loadingPeriodicitys,
  } = useSelector((store) => store.periodicity);
  const loadingClasificacion = useSelector(
    (store) => store.classification.loading
  );
  const dataClasificacion = useSelector(
    (store) => store.classification.classification
  );
  const data = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);

  useEffect(() => {
    // _getMetricaCompetencia();
    // dispatch(getUltimoRegistro());
    setEmpresa("");
    setPeriodo("");
    setFilter("");
    dispatch(resetMetricaCompetencias());
    dispatch(resetPeriodicity());
    dispatch(resetPeriodicityByOrg());
    dispatch(getOrgs(parseInt(2)));
    getAClassification({});
  }, []);

  useEffect(() => {
    if (periodicitys && periodicitys.length > 0 && _periodo !== "") {
      // setPeriodo(periodicitys[periodicitys.length - 1].id);
      if (periodicitys.find((e) => e.anio === n)) {
        _getMetricaCompetencia(
          offset,
          limit,
          "",
          periodicitys.find((e) => e.anio === n).id
        );
      } else {
        _getMetricaCompetencia(
          offset,
          limit,
          "",
          periodicitys[periodicitys.length - 1].id
        );
      }
    }
  }, [periodicitys, _periodo]);

  useEffect(() => {
    if (periodicitys && periodicitys.length > 0) {
      if (periodicitys.find((e) => e.anio === n)) {
        setPeriodo(periodicitys.find((e) => e.anio === n).id);
      } else {
        setPeriodo(periodicitys[periodicitys.length - 1].id);
      }
    }
  }, [periodicitys]);

  useEffect(() => {
    if (ultimoRegistro) {
      setUltimoGrado(ultimoRegistro + 1);
    } else {
      setUltimoGrado(1);
    }
  }, [ultimoRegistro]);

  const pages = Math.ceil(
    metricaCompetencia ? metricaCompetencia.count / limit : 0
  );

  const columns = [
    {
      Header: "Empresa",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad
            ? value.row.original.list_periodicidad[0].list_empresa[0].nombre
            : ""}
        </div>
      ),
    },
    {
      Header: "Clasificación",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad
            ? value.row.original.list_periodicidad[0].list_clasificacion[0]
                .nombre
            : ""}
        </div>
      ),
    },
    {
      Header: "Código",
      accessor: "nombre",
      Filter: "",
    },
    {
      Header: "Descripción",
      accessor: "descripcion",
      Filter: "",
    },
    {
      Header: "Mínimo",
      accessor: "valor_minimo",
      Filter: "",
    },
    {
      Header: "Máximo",
      accessor: "valor_maximo",
      Filter: "",
    },
    {
      Header: "Porcentual",
      accessor: "valor_porcentual",
      Filter: "",
    },
    {
      Header: "Grado",
      accessor: "grado",
      Filter: "",
    },
    {
      Header: "Fecha de cierre",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.periodicidad
            ? moment(value.row.original.list_periodicidad[0].fecha_fin).format(
                "DD/MM/YYYY"
              )
            : ""}
        </div>
      ),
    },
    {
      Header: "Fecha de creación",
      accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons" size={12}>
              edit
            </i>
          </Button>
        </div>
      ),
    },
    {
      id: "customButtons1",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  const filters = [
    { id: "nombre", desc: "Nombre" },
    { id: "descripcion", desc: "Descripción" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
  ];

  const getAClassification = (filt = filter) =>
    dispatch(
      getClassification(
        {
          filter: filt,
        },
        2
      )
    );

  const _getMetricaCompetencia = (
    offs = offset,
    lim = limit,
    filt = filter,
    period = _periodo,
    periods = periodicitys
  ) =>
    dispatch(
      getMetricaCompetencias(
        {
          offset: offs,
          limit: lim,
          tipo_busqueda_2: tipoBusqueda.id,
          filter_2:
            tipoBusqueda.id === "fecha_creacion"
              ? filt !== ""
                ? !isNaN(filt)
                  ? filt
                  : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                      8
                    )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                      4
                    )}-${filt.charAt(0)}${filt.charAt(1)}`
                : filt
              : filt,
          tipo_busqueda: "periodicidad_id",
          filter: period,
        },
        periods
      )
    );

  const onEdit = (item, index) => {
    if (item.periodicidad) {
      setIsOrgSelect(true);
      dispatch(
        getPeriodicityByOrg({
          tipo_busqueda: "empresa__id",
          filter: parseInt(item.list_periodicidad[0].empresa),
          tipo_busqueda_2: "clasificacion_id",
          filter_2: _clasificacion,
          tipo_busqueda_3: "anio",
          filter_3: parseInt(item.list_periodicidad[0].anio),
        })
      );
    }
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteMetricaCompetencias(id, data));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getMetricaCompetencia(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    if (_empresa !== "") {
      setIsOrgSelect(true);
      dispatch(
        getPeriodicityByOrg({
          tipo_busqueda: "empresa__id",
          filter: parseInt(parseInt(_empresa)),
          tipo_busqueda_2: "clasificacion_id",
          filter_2: _clasificacion,
          tipo_busqueda_3: "anio",
          filter_3: parseInt(n),
        })
      );
    } else {
      setIsOrgSelect(false);
    }
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getMetricaCompetencia(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    if (parseInt(req.valor_minimo) >= parseInt(req.valor_maximo)) {
      toastr.info("El valor mínimo no puede ser mayor o igual al valor máximo");
      return;
    }

    req.periodicidad = periodicity.id;
    if (!edit) {
      if (ultimoGrado < 5) {
        setUltimoGrado(ultimoGrado + 1);
      } else {
        setUltimoGrado(1);
      }
      dispatch(saveMetricaCompetencias(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editMetricaCompetencias(req, index, setShowFormModal));
    }
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              MÉTRICAS POR COMPETENCIA
            </h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <Col md="12">
            <Row>
              <Form.Group as={Col} md={4} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Clasificación
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      {/* {!loadingClasificacion && (
                            <> */}
                      <Col sm={loadingClasificacion ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="clasificacion"
                          name="clasificacion"
                          className="col rounded-pill"
                          defaultValue=""
                          onChange={(e) => {
                            e.preventDefault();

                            setClasificacion(e.currentTarget.value);
                            if (_empresa !== "") {
                              dispatch(
                                getPeriodicity({
                                  tipo_busqueda: "empresa__id",
                                  filter: parseInt(_empresa),

                                  tipo_busqueda_2: "clasificacion_id",
                                  filter_2: parseInt(e.currentTarget.value),
                                })
                              );
                            }
                            // _getFactor(
                            //   offset,
                            //   limit,
                            //   filter,
                            //   e.currentTarget.value
                            // );
                            //     dispatch(
                            //       getPeriodicity({
                            //        tipo_busqueda: "empresa__id",
                            //        filter: parseInt(e.currentTarget.value),
                            //</Col>     })
                            //   );
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            //  selected
                            //  disabled
                          >
                            Selecionar clasificación
                          </option>
                          {dataClasificacion
                            ? dataClasificacion.length > 0 &&
                              dataClasificacion
                                .sort((a, b) =>
                                  a.nombre > b.nombre
                                    ? 1
                                    : b.nombre > a.nombre
                                    ? -1
                                    : 0
                                )
                                .map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.nombre ? item.nombre : ""}
                                  </option>
                                ))
                            : ""}
                        </Form.Control>
                      </Col>
                      {/* </>
                          )} */}
                      {loadingClasificacion ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md={4} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Empresa
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loadingOrgs ? "10" : "12"}>
                        <Form.Control
                          as="select"
                          id="empresa"
                          name="empresa"
                          className="col rounded-pill"
                          defaultValue=""
                          disabled={loadingOrgs}
                          onChange={(e) => {
                            e.preventDefault();
                            setEmpresa(e.currentTarget.value);
                            if (_clasificacion !== "") {
                              dispatch(
                                getPeriodicity({
                                  tipo_busqueda: "empresa__id",
                                  filter: parseInt(e.currentTarget.value),

                                  tipo_busqueda_2: "clasificacion_id",
                                  filter_2: parseInt(_clasificacion),
                                })
                              );
                            }
                            // _getMetricByFactor(
                            //   offset,
                            //   limit,
                            //   filter,
                            //   e.currentTarget.value
                            // );
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar Empresa
                          </option>
                          {data.length > 0 &&
                            data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loadingOrgs ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md={4} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Periodicidad
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      {!loadingPeriodicitys && (
                        <>
                          <Col sm={loadingPeriodicitys ? "10" : "12"}>
                            <Form.Control
                              as="select"
                              id="periodicidad"
                              name="periodicidad"
                              className="col rounded-pill"
                              defaultValue={
                                periodicitys &&
                                periodicitys.length > 0 &&
                                periodicitys.find((e) => e.anio === n)
                                  ? periodicitys.find((e) => e.anio === n).id
                                  : periodicitys && periodicitys.length > 0
                                  ? periodicitys[periodicitys.length - 1].id
                                  : ""
                              }
                              disabled={
                                loadingPeriodicitys ||
                                (periodicitys && periodicitys.length === 0)
                              }
                              onChange={(e) => {
                                e.preventDefault();
                                setPeriodo(e.currentTarget.value);
                                _getMetricaCompetencia(
                                  offset,
                                  limit,
                                  filter,
                                  e.currentTarget.value
                                );
                              }}
                            >
                              <option
                                className="text-muted"
                                value=""
                                selected
                                disabled
                              >
                                Selecionar periodicidad
                              </option>
                              {periodicitys.length > 0 &&
                                periodicitys.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.list_frecuencia[0].nombre}
                                    {" - "}
                                    {moment(item.fecha_fin).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </option>
                                ))}
                            </Form.Control>
                          </Col>
                        </>
                      )}
                      {loadingPeriodicitys ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Col>
          {!!metricaCompetenciaFalla && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {metricaCompetenciaFalla}
            </Alert>
          )}
          {loaderMetricaCompetencia ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : metricaCompetencia != null &&
            metricaCompetencia.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable
                    columns={columns}
                    data={metricaCompetencia.data}
                  />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={metricaCompetencia.count}
                pages={pages}
                pagFunc={_getMetricaCompetencia}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              nombre: edit ? editItem.nombre : "",
              descripcion: edit ? editItem.descripcion : "",
              valor_minimo: edit ? editItem.valor_minimo : "",
              valor_maximo: edit ? editItem.valor_maximo : "",
              valor_porcentual: edit ? editItem.valor_porcentual : "",
              grado: edit ? editItem.grado : ultimoGrado,
              empresa: edit
                ? editItem.periodicidad
                  ? editItem.list_periodicidad[0].empresa
                  : ""
                : _empresa,
              clasificacion: _clasificacion,
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit
                      ? "Editar Metrica Competencia"
                      : "Crear Metrica Competencia"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {!loadingPeriodicity &&
                    !edit &&
                    periodicityError === "" &&
                    !periodicity.id &&
                    isOrgSelect && (
                      <Alert variant="danger" className="mt-1 mb-2 mx-3">
                        El periodo de evaluación ya cerro o no se ha definido,
                        para mas información comunicarse con el administrador.
                      </Alert>
                    )}
                  {!loadingPeriodicity &&
                    !edit &&
                    periodicityError === "" &&
                    periodicity.id &&
                    isOrgSelect && (
                      <Alert variant="info" className="mt-1 mb-2 mx-3">
                        Si el periodo de evaluación ya esta siendo utilizado no
                        podra eliminar el registro.
                      </Alert>
                    )}
                  {edit &&
                    moment(fecha) >
                      moment(editItem.list_periodicidad[0].fecha_fin) && (
                      <Alert variant="danger" className="mt-1 mb-2 mx-3">
                        La plantilla ya ha cerrado.
                      </Alert>
                    )}
                  {(_clasificacion === "" || _empresa === "") && (
                    <Alert variant="danger" className="mt-1 mb-2">
                      Debe seleccionar una clasificación y una empresa
                      previamente, para poder agregar un nuevo registro.
                    </Alert>
                  )}
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Empresa
                    </Form.Label>
                    <Form.Control
                      as="select"
                      id="empresa"
                      name="empresa"
                      className="col rounded-pill"
                      isInvalid={touched.empresa && errors.empresa}
                      isValid={touched.empresa && !errors.empresa}
                      onBlur={handleBlur("empresa")}
                      value={values.empresa}
                      // defaultValue={empresa}
                      // disabled={edit || loadingOrgs || loadingPeriodicity}
                      disabled
                      onChange={(e) => {
                        // dispatch(
                        //   getPeriodicityByOrg({
                        //     tipo_busqueda: "empresa__id",
                        //     filter: parseInt(e.currentTarget.value),
                        //   })
                        // );
                        // if (e.currentTarget.value !== "") {
                        //   setIsOrgSelect(true);
                        // } else {
                        //   setIsOrgSelect(false);
                        // }
                        handleChange(e);
                      }}
                    >
                      <option className="text-muted" value="" selected disabled>
                        Selecionar Empresa
                      </option>
                      {data.length > 0 &&
                        data.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.nombre}
                          </option>
                        ))}
                    </Form.Control>
                    {touched.empresa && errors.empresa && (
                      <Col>
                        <small className="text-danger">{errors.empresa}</small>
                      </Col>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Clasificacion
                    </Form.Label>
                    <Form.Control
                      as="select"
                      id="clasificacion"
                      name="clasificacion"
                      className="col rounded-pill"
                      isInvalid={touched.clasificacion && errors.clasificacion}
                      isValid={touched.clasificacion && !errors.clasificacion}
                      onBlur={handleBlur("clasificacion")}
                      value={values.clasificacion}
                      disabled
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    >
                      <option className="text-muted" value="" selected disabled>
                        Selecionar clasificacion
                      </option>
                      {dataClasificacion
                        ? dataClasificacion.length > 0 &&
                          dataClasificacion.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.nombre ? item.nombre : ""}
                            </option>
                          ))
                        : ""}
                    </Form.Control>
                    {touched.clasificacion && errors.clasificacion && (
                      <Col>
                        <small className="text-danger">
                          {errors.clasificacion}
                        </small>
                      </Col>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Código
                    </Form.Label>
                    <Form.Control
                      name="nombre"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre}
                      placeholder="Código"
                      onBlur={handleBlur("nombre")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.nombre && !!errors.nombre}
                      disabled={
                        edit && n !== editItem.list_periodicidad[0].anio
                        // edit &&
                        // moment(fecha) >
                        //   moment(editItem.list_periodicidad[0].fecha_fin)
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre}
                    </Form.Control.Feedback>
                    {metricaCompetenciaFormError &&
                    typeof metricaCompetenciaFormError === "object" &&
                    metricaCompetenciaFormError.nombre ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {metricaCompetenciaFormError.nombre.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>

                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Descripción
                    </Form.Label>
                    <Form.Control
                      name="descripcion"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.descripcion}
                      placeholder="Descripción"
                      //onBlur={handleBlur("descripcion")}
                      onChange={(e) => handleChange(e)}
                      //     max={12}
                      isInvalid={touched.descripcion && !!errors.descripcion}
                      disabled={
                        edit && n !== editItem.list_periodicidad[0].anio
                        // edit &&
                        // moment(fecha) >
                        //   moment(editItem.list_periodicidad[0].fecha_fin)
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.descripcion}
                    </Form.Control.Feedback>
                    {metricaCompetenciaFormError &&
                    typeof metricaCompetenciaFormError === "object" &&
                    metricaCompetenciaFormError.descripcion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {metricaCompetenciaFormError.descripcion.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>

                  <Form.Group as={Col} className="mb-1">
                    <Row as={Col} className="mb-3">
                      <Form.Label column sm="3" md="3">
                        Rango
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Label column sm="6" md="6">
                          De
                        </Form.Label>
                        <Form.Control
                          name="valor_minimo"
                          className="rounded-pill"
                          required
                          type="number"
                          value={values.valor_minimo}
                          placeholder="0"
                          //onBlur={handleBlur("valor_minimo)}
                          onChange={(e) => handleChange(e)}
                          min={0}
                          //    max={12}
                          isInvalid={
                            touched.valor_minimo && !!errors.valor_minimo
                          }
                          disabled={
                            edit && n !== editItem.list_periodicidad[0].anio
                            // edit &&
                            // moment(fecha) >
                            //   moment(editItem.list_periodicidad[0].fecha_fin)
                          }
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.valor_minimo}
                        </Form.Control.Feedback>
                        {metricaCompetenciaFormError &&
                        typeof metricaCompetenciaFormError === "object" &&
                        metricaCompetenciaFormError.valor_minimo ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {metricaCompetenciaFormError.valor_minimo.map(
                              (item) => (
                                <li>{item}</li>
                              )
                            )}
                          </ul>
                        ) : null}
                      </Col>
                      <Col sm={4}>
                        <Form.Label column sm="6" md="6">
                          Hasta
                        </Form.Label>
                        <Form.Control
                          name="valor_maximo"
                          className="rounded-pill"
                          required
                          type="number"
                          value={values.valor_maximo}
                          placeholder="0"
                          //onBlur={handleBlur("valor_minimo)}
                          onChange={(e) => handleChange(e)}
                          min={0}
                          //    max={12}
                          isInvalid={
                            touched.valor_maximo && !!errors.valor_maximo
                          }
                          disabled={
                            edit && n !== editItem.list_periodicidad[0].anio
                            // edit &&
                            // moment(fecha) >
                            //   moment(editItem.list_periodicidad[0].fecha_fin)
                          }
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {errors.valor_maximo}
                        </Form.Control.Feedback>
                        {metricaCompetenciaFormError &&
                        typeof metricaCompetenciaFormError === "object" &&
                        metricaCompetenciaFormError.valor_maximo ? (
                          <ul className="list-unstyled text-danger ml-2">
                            {metricaCompetenciaFormError.valor_maximo.map(
                              (item) => (
                                <li>{item}</li>
                              )
                            )}
                          </ul>
                        ) : null}
                      </Col>
                    </Row>
                  </Form.Group>

                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Valor Porcentual %
                    </Form.Label>
                    <Form.Control
                      name="valor_porcentual"
                      className="rounded-pill"
                      required
                      type="number"
                      value={values.valor_porcentual}
                      placeholder="0%"
                      //onBlur={handleBlur("valor_minimo)}
                      onChange={(e) => handleChange(e)}
                      min={0}
                      //    max={12}
                      isInvalid={
                        touched.valor_porcentual && !!errors.valor_porcentual
                      }
                      disabled={
                        edit && n !== editItem.list_periodicidad[0].anio
                        // edit &&
                        // moment(fecha) >
                        //   moment(editItem.list_periodicidad[0].fecha_fin)
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.valor_porcentual}
                    </Form.Control.Feedback>
                    {metricaCompetenciaFormError &&
                    typeof metricaCompetenciaFormError === "object" &&
                    metricaCompetenciaFormError.valor_porcentual ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {metricaCompetenciaFormError.valor_porcentual.map(
                          (item) => (
                            <li>{item}</li>
                          )
                        )}
                      </ul>
                    ) : null}
                  </Form.Group>

                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Grado
                    </Form.Label>
                    <Form.Control
                      name="grado"
                      className="rounded-pill"
                      required
                      type="number"
                      //value={values.grado}
                      value={values.grado}
                      placeholder="0"
                      //onBlur={handleBlur("valor_minimo)}
                      onChange={(e) => handleChange(e)}
                      min={1}
                      max={5}
                      isInvalid={touched.grado && !!errors.grado}
                      disabled
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.grado}
                    </Form.Control.Feedback>
                    {metricaCompetenciaFormError &&
                    typeof metricaCompetenciaFormError === "object" &&
                    metricaCompetenciaFormError.grado ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {metricaCompetenciaFormError.grado.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  {edit && n !== editItem.list_periodicidad[0].anio ? null : ( //   moment(editItem.list_periodicidad[0].fecha_fin) // moment(fecha) > // edit &&
                    <>
                      <Button
                        className="rounded-pill"
                        disabled={
                          saveLoaderMetricaCompetencia ||
                          (!loadingPeriodicity &&
                            !edit &&
                            periodicityError === "" &&
                            !periodicity.id &&
                            isOrgSelect) ||
                          (edit &&
                            moment(fecha) >
                              moment(
                                editItem.list_periodicidad[0].fecha_fin
                              )) ||
                          loadingOrgs ||
                          loadingPeriodicity ||
                          values.empresa === "" ||
                          (!edit && _periodo === "")
                        }
                        variant="primary"
                        type="submit"
                      >
                        {saveLoaderMetricaCompetencia && (
                          <Spinner
                            className="mr-2"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                        Guardar
                      </Button>
                    </>
                  )}
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default MetricaCompetencia;
